import { cfReferenceList } from 'ggApp/modules/contentful/utils/mappers/cfReferenceList';
import { mapCfEntityToCfUspCard } from 'ggApp/modules/contentful/models/uspCard/mapper';

export const mapCfEntityToUspCardsWidget = (cfEntity = {}) => {
    const { fields } = cfEntity;
    const result = {};
    const { heading, steps } = fields || {};

    Object.assign(result, {
        title: heading,
        steps: cfReferenceList(steps).map((card) => mapCfEntityToCfUspCard(card)),
    });

    return result;
};
